module.exports = __webpack_public_path__ + "img/19451038004872.cf386076.png";